import type { KeyboardEvent } from 'react';

/** Mac keyboards submit with ⌘, everyone else with Ctrl. */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const platform =
    (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ??
    navigator.platform;
  return /mac|iphone|ipad/i.test(platform);
}

/** "⌘↵" on a Mac, "Ctrl ↵" elsewhere. */
export function submitShortcutLabel(): string {
  return isApplePlatform() ? '⌘↵' : 'Ctrl ↵';
}

/** The `aria-keyshortcuts` value for the same keys. */
export function submitShortcutAria(): string {
  return isApplePlatform() ? 'Meta+Enter' : 'Control+Enter';
}

/** Ctrl+Enter or ⌘+Enter. Both are accepted on every platform. */
export function isSubmitShortcut(e: KeyboardEvent): boolean {
  return e.key === 'Enter' && (e.ctrlKey || e.metaKey);
}
